// @flow
import React from 'react'
import cn from 'classnames/bind'

import { Tr, Th, Td } from 'app/common/ui-components/table'
import ComplexTooltip from 'app/common/ui-components/complex-tooltip'

import { type ActualItem } from './useActualItems'
import { Consist } from './Consist'
import styles from './ItemRow.scss'
import { isValueZero } from 'app/common/templates-next/table-template'

const cx = cn.bind(styles)

/**
 *  Обычная строка таблицы
 */

type Props = {
  currency: string,
  columns: Array<string>,
} & ActualItem

const ItemRow = ({ title, dishItems, currency, columns, ...others }: Props) => {
  const { sum, cost } = others
  const rowId = `${title}${sum}`

  return (
    <Tr>
      {columns.map((key) => {
        if (key === 'title')
          return (
            <Th key={key} id={rowId} scope="row" alignLeft>
              {dishItems ? (
                <ComplexTooltip
                  header={title}
                  headerSuffix={`${cost}${currency}`}
                  items={dishItems}
                >
                  <span className={styles.complexTitle}>{title}</span>
                </ComplexTooltip>
              ) : (
                title
              )}
            </Th>
          )

        if (key === 'consist')
          return (
            <Td key={key} headers={`header_${key} ${rowId}`} alignLeft>
              {dishItems ? <Consist dishItems={dishItems} /> : '\u00A0'}
            </Td>
          )

        return (
          <Td
            key={key}
            headers={`header_${key} ${rowId}`}
            className={cx({ zero: isValueZero(others[key]) })}
            alignRight
          >
            {others[key]}
          </Td>
        )
      })}
    </Tr>
  )
}

export default ItemRow
